import { MaxDialogDirective } from './directives/max-dialog.directive';
import { MaxDialogComponent } from './max-dialog.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

@NgModule({
    imports: [CommonModule],
    declarations: [MaxDialogComponent, MaxDialogDirective],
    entryComponents: [MaxDialogComponent]
})
export class MaxDialogModule { }
